module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0138.jpg?v=c7d266f2";